import React, { createContext, useState, useEffect } from 'react';

export const CsrfTokenContext = createContext();

export const CsrfTokenProvider = ({ children }) => {
    const [csrfToken, setCsrfToken] = useState('');        
        
    useEffect(() => {
        const fetchCsrfToken = async () => {        
            const response = await fetch(`/api/get_csrf_token`);
            const data = await response.json();
            setCsrfToken(data.csrf_token);
        };

        fetchCsrfToken();
        // Optionally refresh the token periodically, e.g., every 30 minutes
        const tokenRefreshInterval = setInterval(fetchCsrfToken, 30 * 60 * 1000);
        return () => clearInterval(tokenRefreshInterval);
    }, []);

    return (
        <CsrfTokenContext.Provider value={csrfToken}>
            {children}
        </CsrfTokenContext.Provider>
    );
};